// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-33d52984] .body-content img{width:100%;height:100%;margin-left:auto;margin-right:auto;object-fit:cover}[data-v-33d52984] .img1{max-width:1024px;margin-top:2rem;margin-bottom:2rem}@media (min-width:1024px){[data-v-33d52984] .img1{margin-top:3.5rem;margin-bottom:3.5rem}}[data-v-33d52984] .img2{max-width:508px;max-height:194px;margin-top:1rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
